<db-dialog-wrapper [dialog]="this" [width]="'1000px'" [height]="'674px'" [noBorder]="true" [className]="'db-dialog-wrapper__content_how-to-video'" [closeButtonTop]="'-22px'" [closeButtonRight]="'-22px'">
  <iframe width="100%" height="100%" [src]="url | safe" frameborder="0" allow="autoplay" allowfullscreen></iframe>
</db-dialog-wrapper>
